import React from 'react';
import { styled } from '@erecruit/ui-kit';
import { toast, ToastContainer } from 'react-toastify';

const ErrorContainer = styled(({ className }) => (
  <ToastContainer
    containerId="error"
    enableMultiContainer
    position={toast.POSITION.TOP_CENTER}
    className={className}
    autoClose={15000}
    closeOnClick
  />
))(({ theme }) => ({
  top: theme.topBarHeight + 10,
  '.Toastify__toast': {
    borderRadius: 8,
    textAlign: 'justify',
    backgroundColor: theme.newColors.statusCritical,
    color: theme.newColors.bodyTertiary,
  },
}));

export default ErrorContainer;
